module.exports = __webpack_public_path__ + "img/logo_propesca_texto_splash.686259c3.svg";